import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { Paper, Typography, Skeleton, Box } from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const CHANNEL_COLORS = {
  LOCAL: '#1976d2',
  WEB: '#66bb6a',
  B2B: '#ffa726',
  B2B_EXTERNAL: '#7e57c2',
  B2B_FRANCHISE: '#ff7043',
};

const CHANNEL_LABELS = {
  LOCAL: 'Local',
  WEB: 'Web',
  B2B: 'B2B',
  B2B_EXTERNAL: 'B2B externo',
  B2B_FRANCHISE: 'Franquicias',
};

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const item = payload[0]?.payload;

  return (
    <Box p={1} bgcolor="white" boxShadow={2} borderRadius={1}>
      <Typography variant="subtitle2">{item.label}</Typography>
      <Typography variant="body2">💰 Ventas: {formatMoney(item.value)}</Typography>
      <Typography variant="body2">🎟️ Tickets: {item.ticketCount.toLocaleString()}</Typography>
    </Box>
  );
};

const SalesByChannelChart = ({ data = [], loading, title = 'Ventas por canal' }) => {
  const chartData = data.map((item) => ({
    ...item,
    label: CHANNEL_LABELS[item.channel] || item.channel,
    color: CHANNEL_COLORS[item.channel] || '#90caf9',
  }));

  return (
    <Paper elevation={2} sx={{ p: 2, height: 360 }}>
      <Typography variant="subtitle1" gutterBottom>
        {title}
      </Typography>
      <Box sx={{ width: '100%', height: 300 }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={300} />
        ) : chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} margin={{ top: 20, right: 20, bottom: 0, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="label" />
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="value">
                {chartData.map((entry, index) => (
                  <Cell key={`channel-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default SalesByChannelChart;
